<script>
import ListingModel from "@/views/Evaluation/Gravity/Components/ListingModel.vue";

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel type="EVALUATION_SKILL"/>
</template>